import styles from "./BlockedNotice.module.css";

/**
 * Rendered by AuthProvider instead of the app shell when the signed-in user's
 * access has been removed. Deliberately bare — no nav, no search, no chat —
 * since a blocked user already has zero permissions and empty content
 * visibility server-side; there is nothing here for them to do but ask.
 */
export function BlockedNotice() {
  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <h1 className={styles.heading}>Your access has been removed</h1>
        <p className={styles.body}>Talk to a director if you think this is a mistake.</p>
      </div>
    </div>
  );
}
